/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup } from "react-bootstrap-3";

function TextAreaGroup({ value, hasErrors, onChange, field, rows, readOnly, disabled }) {
  const { fieldName } = field;
  return (
    <div>
      <FormGroup>
        <FormControl
          value={value}
          name={fieldName}
          rows={rows || "5"}
          componentClass="textarea"
          className={`form-control ${hasErrors && "parsley-error"}`}
          onChange={event => onChange({ event, field: fieldName })}
          readOnly={readOnly}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
}

TextAreaGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default TextAreaGroup;
